import { APIResponse } from '@answerr/types';
import {
  QuizResponse,
  QuizzesResponse,
  CreateQuizInput,
  UpdateQuizInput,
} from '../components/main/quiz/types';
import http from '../utils/http-common';
import { DeleteFilesDataInput } from '../types/agent.types';

const config = {
  headers: {
    'Content-Type': 'multipart/form-data;',
  },
};

const createQuiz = (data: CreateQuizInput) => {
  return http.post<QuizResponse>('/quizzes/create', data);
};

const getAllQuizzes = () => {
  return http.post<QuizzesResponse>('/quizzes/list', {});
};

const getQuizById = (quizId: string) => {
  return http.post<QuizResponse>('/quizzes/get-quiz', { quizId });
};

const updateQuiz = (data: UpdateQuizInput) => {
  return http.post<QuizResponse>('/quizzes/update', data);
};

const updateQuizUsers = (quizId: string, allowedUserIds: string[], allowedGroupIds: string[]) => {
  return http.patch<QuizResponse>('/quizzes/update-users', { quizId, allowedUserIds, allowedGroupIds });
};

const deleteQuiz = (quizId: string) => {
  return http.post<APIResponse>('/quizzes/delete', { quizId });
};

const scrapeUrl = (urls: string[], quizId: string, orgId: string) => {
  return http.post<APIResponse>('/quizzes/scrape-url', { urls, quizId, orgId });
};

const uploadFilesToPinecone = (formData: any) => {
  return http.post<QuizResponse>(
    `${process.env.REACT_APP_API_BASE_URL}/adv/pc/upload-quiz-files`,
    formData,
    config
  );
};

const deleteFiles = (data: DeleteFilesDataInput) => {
  return http.post<APIResponse>(
    `${process.env.REACT_APP_API_BASE_URL}/adv/pc/delete-quiz-files`,
    data
  );
};

const generateQuiz = (quizId: string) => {
  return http.post<QuizResponse>('/quizzes/generate', { quizId });
};

const updateQuizQuestion = (quizId: string, questionIndex: number, questionData: Record<string, any>) => {
  return http.post<QuizResponse>('/quizzes/update-question', { quizId, questionIndex, questionData });
};

const publishQuiz = (quizId: string) => {
  return http.post<QuizResponse>('/quizzes/publish', { quizId });
};

const QuizService = {
  createQuiz,
  getAllQuizzes,
  getQuizById,
  updateQuiz,
  updateQuizUsers,
  updateQuizQuestion,
  publishQuiz,
  deleteQuiz,
  scrapeUrl,
  uploadFilesToPinecone,
  deleteFiles,
  generateQuiz,
};

export default QuizService;
